// extracted by mini-css-extract-plugin
module.exports = {"textWhite":"MediaText_textWhite__R7tAV"};